/* eslint-disable @typescript-eslint/no-non-null-assertion */

import Space from "@sentrei/common/models/Space";

const serializeSpace = (
  snap: firebase.firestore.DocumentSnapshot<Space.Response>,
): Space.Get => {
  const data = snap.data()!;
  const {joined} = data;

  return {
    ...data,
    createdAt: data.createdAt,
    uid: snap.id,
    joined: joined || null,
    updatedAt: data.updatedAt,
  };
};

export default serializeSpace;
